export const CurrencyLabel = ({ currency }) => {
  const decodeHtmlEntities = (str) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    return textarea.value;
  };

  return decodeHtmlEntities(currency);
};
